import _ from 'lodash'
import { JSONEditor } from '@json-editor/json-editor'
import SelectEditor from './select'
import Choices from 'choices.js'

// enable Choices.js
window.Choices = Choices

const BaseEditor = JSONEditor.defaults.editors.choices
class ChoicesEditor extends BaseEditor {
  constructor (options, defaults) {
    super(options, defaults)
    this.isBasic = options.jsoneditor.options.isBasic || false
  }
  postBuild () {
    super.postBuild()
    this.container.classList.add('choices-format')
    if (this.isBasic) {
      this.disable(true)
    }
  }

  typecast (value) {
    if (this.schema.type === 'object' && _.isObject(value)) {
      value = JSON.stringify(value)
      console.log('JSON.stringify:', value)
    }
    return super.typecast(value)
  }

  getValue () {
    if (!this.dependenciesFulfilled) {
      return undefined
    }

    if (this.schema.type === 'object' && _.isString(this.value)) {
      let result = this.value
      try {
        result = JSON.parse(this.value)
        console.log('JSON.parse:', result)
        return result
      } catch (err) {
        console.error(err)
      }
    }

    return this.typecast(this.value)
  }
}

export default ChoicesEditor
